import Vue from 'vue'
import Vuex from 'vuex'
import request from '../utils/request'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    token: localStorage.getItem('token') || '',
    sidebar: {
      opened: true
    },
    menuList: JSON.parse(localStorage.getItem('menuList') || '[]')
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebar.opened = !state.sidebar.opened
    },
    LOGOUT(state) {
      state.user = null
      state.token = ''
      state.menuList = []
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('menuList')
    },
    SET_MENU_LIST(state, menuList) {
      state.menuList = menuList
      localStorage.setItem('menuList', JSON.stringify(menuList))
    }
  },
  actions: {
    login({ commit, dispatch }, { email, password, remember }) {
      return new Promise((resolve, reject) => {
        console.log('=== 开始登录 ===')
        console.log('登录参数:', { email, password, remember })
        
        request.post('/agent/login/login', {
          email,
          password,
          remember
        })
        .then(response => {
          console.log('登录接口响应:', response)
          console.log('响应data:', response.data)
          
          const { access_token, user_info } = response.data
          console.log('解析出的token:', access_token)
          console.log('解析出的用户信息:', user_info)
          
          commit('SET_TOKEN', access_token)
          commit('SET_USER', user_info)
          
          console.log('=== 登录成功，开始获取菜单 ===')
          dispatch('getMenuList').then(() => {
            console.log('=== 菜单获取成功 ===')
            resolve(response)
          }).catch(err => {
            console.error('获取菜单失败:', err)
            reject(err)
          })
        })
        .catch(error => {
          console.error('登录失败:', error)
          reject(error)
        })
      })
    },
    getMenuList({ commit }) {
      return new Promise((resolve, reject) => {
        request.get('/agent/menu/getMenuList')
        .then(response => {
          console.log('菜单接口响应:', response)
          console.log('菜单数据:', response.data)
          const menuList = response.data || []
          console.log('处理后的菜单列表:', menuList)
          commit('SET_MENU_LIST', menuList)
          resolve(menuList)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    getEmailCode({ }, { email, type }) {
      return new Promise((resolve, reject) => {
        request.get('/agent/login/getEmailCode', {
          params: {
            email,
            type
          }
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    
    register({ commit }, { email, code, name, password, agree }) {
      return new Promise((resolve, reject) => {
        request.post('/agent/login/register', {
          email,
          code,
          name,
          password,
          agree
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    
    resetPassword({ }, { email, code, password, ret_password }) {
      return new Promise((resolve, reject) => {
        request.post('/agent/login/resetPassword', {
          email,
          code,
          password,
          ret_password
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        request.post('/agent/login/logout')
        .then(() => {
          commit('LOGOUT')
          resolve()
        })
        .catch(error => {
          commit('LOGOUT')
          reject(error)
        })
      })
    },
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    sidebarOpened: state => state.sidebar.opened,
    menuList: state => state.menuList
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js